import { stylesheet } from 'typestyle';
import * as csx from 'csstips';

import { regularGrayText, linkBlueText } from '@src/styles/general';

export default stylesheet({
  container: {
    ...csx.horizontal,
    ...csx.betweenJustified,

    margin: '0 25px',
    padding: '25px 0 25px 0',
    borderTop: '1px solid #dadada',

    '@media (max-width: 750px)': {
      display: 'block'
    }
  },
  left: {
    flexBasis: '26%',
    marginRight: 15,

    '@media (max-width: 940px)': {
      flexBasis: '50%'
    },

    '@media (max-width: 750px)': {
      width: '100%',
      marginRight: 0
    }
  },
  right: {
    ...csx.horizontal,
    ...csx.betweenJustified,

    flexBasis: 'calc(74% - 15px)',

    $nest: {
      '& > *:nth-child(1)': {
        marginRight: 35
      },

      '& > *:nth-child(2)': {
        flex: 1
      },

      '@media (max-width: 940px)': {
        display: 'block',
        flexBasis: '50%',

        '& > *:nth-child(1)': {
          marginRight: 0
        },

        '& > *:nth-child(2)': {
          marginTop: 35
        }
      },

      '@media (max-width: 750px)': {
        width: '100%',
        marginTop: 40
      }
    }
  },
  list: { listStyle: 'none', margin: 0, padding: 0, width: '100%' },
  inlineList: {
    $nest: {
      '& > *': {
        display: 'inline-block'
      }
    }
  },
  item: {
    position: 'relative',
    color: regularGrayText,

    $nest: {
      '& a': {
        color: regularGrayText
      },
      '& a:hover': {
        color: linkBlueText
      }
    }
  },
  underlinedItem: {
    $nest: {
      '& a': {
        textDecoration: 'underline'
      },
      '& a:hover': {
        color: regularGrayText
      }
    }
  },
  itemWithIcon: { paddingLeft: 22 },
  icon: { position: 'absolute', left: 0, marginTop: 3 }
});
